import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  details: undefined,
  profile: undefined,
  userVerification: undefined,
  facilitators: [],
  socialEmail: undefined,
  socialPersonExternalReference: undefined,
  adminRole: undefined,
  notifications: [],
  adminPings: undefined,
  userGroups: [],
};

export const PartySlice = createSlice({
  name: 'party',
  initialState,
  reducers: {
    setDetails: (state, action) => {
      state.details = action.payload;
    },
    setSocialEmail: (state, action) => {
      state.socialEmail = action.payload;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setSocialPersonExternalReference: (state, action) => {
      state.socialPersonExternalReference = action.payload;
    },
    setOrganisation: (state, action) => {
      state.organisation = action.payload;
    },
    setUserVerification: (state, action) => {
      state.userVerification = action.payload;
    },
    setFacilitators: (state, action) => {
      state.facilitators = action.payload;
    },
    setAccounts: (state, action) => {
      state.accounts = action.payload;
    },
    setAdminRole: (state, action) => {
      state.adminRole = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setAdminPings: (state, action) => {
      state.adminPings = action.payload;
    },
    setUserGroups: (state, action) => {
      state.userGroups = action.payload;
    },
    resetPartySlice: () => initialState,
  },
});

export const {
  setDetails,
  setProfile,
  setSocialEmail,
  setSocialPersonExternalReference,
  setFacilitators,
  setOrganisation,
  setUserVerification,
  setAccounts,
  setAdminRole,
  setNotifications,
  setAdminPings,
  setUserGroups,
  resetPartySlice,
} = PartySlice.actions;

export default PartySlice.reducer;
